import { render, staticRenderFns } from "./SimpleUploadDownloader.vue?vue&type=template&id=d2d56e3c&"
import script from "./SimpleUploadDownloader.vue?vue&type=script&lang=ts&"
export * from "./SimpleUploadDownloader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports